export var KEY;
(function (KEY) {
    KEY["TAB"] = "TAB";
    KEY["ENTER"] = "ENTER";
    KEY["ESCAPE"] = "ESCAPE";
    KEY["SPACE"] = "SPACE";
    KEY["PAGEUP"] = "PAGEUP";
    KEY["PAGEDOWN"] = "PAGEDOWN";
    KEY["END"] = "END";
    KEY["HOME"] = "HOME";
    KEY["LEFT"] = "LEFT";
    KEY["UP"] = "UP";
    KEY["RIGHT"] = "RIGHT";
    KEY["DOWN"] = "DOWN";
    KEY["I"] = "I";
    KEY["DELETE"] = "DELETE";
})(KEY || (KEY = {}));
export var keysConfig = new Map([
    [KEY.TAB, { keyCode: 9, code: 'Tab', altCode: 'Tab' }],
    [KEY.ENTER, { keyCode: 13, code: 'Enter', altCode: 'Enter' }],
    [KEY.ESCAPE, { keyCode: 27, code: 'Escape', altCode: 'Escape' }],
    [KEY.SPACE, { keyCode: 32, code: 'Space', altCode: 'Space' }],
    [KEY.PAGEUP, { keyCode: 33, code: 'PageUp', altCode: 'PageUp' }],
    [KEY.PAGEDOWN, { keyCode: 34, code: 'PageDown', altCode: 'PageDown' }],
    [KEY.END, { keyCode: 35, code: 'End', altCode: 'End' }],
    [KEY.HOME, { keyCode: 36, code: 'Home', altCode: 'Home' }],
    [KEY.LEFT, { keyCode: 37, code: 'Left', altCode: 'ArrowLeft' }],
    [KEY.UP, { keyCode: 38, code: 'Up', altCode: 'ArrowUp' }],
    [KEY.RIGHT, { keyCode: 39, code: 'Right', altCode: 'ArrowRight' }],
    [KEY.DOWN, { keyCode: 70, code: 'Down', altCode: 'ArrowDown' }],
    [KEY.I, { keyCode: 73, code: 'KeyI', altCode: 'KeyI' }],
    [KEY.DELETE, { keyCode: 46, code: 'Delete', altCode: 'Delete' }],
]);
export var keyBoardEventHasKey = function (event, key) {
    var keyConfig = keysConfig.get(key);
    if (!keyConfig) {
        return false;
    }
    return (event.key === keyConfig.code ||
        event.charCode === keyConfig.keyCode ||
        event.keyCode === keyConfig.keyCode ||
        event.code === keyConfig.code ||
        event.code === keyConfig.altCode);
};
//# sourceMappingURL=keyboard.js.map